export const READY = "ready";
export const SEARCHING = "searching";
export const COLD = "cold";
export const WARM = "warm";
export const HOT = "hot";
export const DONE = "done";

export const SEARCH = "PATIENTS.SEARCH";
export const SEARCH_DONE = "PATIENTS.DONE";
